const BASE = '';

function getToken() {
  return localStorage.getItem('token');
}

async function apiFetch(path, opts = {}) {
  const res = await fetch(`${BASE}${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
      ...(opts.headers || {}),
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || 'API Error');
  }
  return res.json();
}

function exportDownload(path, params = {}) {
  const q = new URLSearchParams(params).toString();
  const url = `${BASE}${path}?${q}`;
  fetch(url, { headers: { Authorization: `Bearer ${getToken()}` } })
    .then(res => {
      if (!res.ok) throw new Error('Export failed');
      const cd = res.headers.get('Content-Disposition') || '';
      const match = cd.match(/filename="?([^"]+)"?/);
      const filename = match ? match[1] : 'export.csv';
      return res.blob().then(blob => ({ blob, filename }));
    })
    .then(({ blob, filename }) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
    })
    .catch(e => alert('Export error: ' + e.message));
}

export const api = {
  dashboard: {
    summary: (params = {}) => apiFetch(`/api/dashboard/summary?${new URLSearchParams(params)}`),
  },

  companies: {
    list:   (params = {}) => apiFetch(`/api/companies/list?${new URLSearchParams(params)}`),
    export: (params = {}) => exportDownload('/api/companies/export', params),
    markContacted:   (cin, note, contactedVia, hasCalled) => apiFetch(`/api/companies/${cin}/contact`, {
      method: 'POST',
      body: JSON.stringify({
        note,
        contacted_via: Array.isArray(contactedVia) ? contactedVia : [],
        has_called: hasCalled || false,
      }),
    }),
    unmarkContacted: (cin) => apiFetch(`/api/companies/${cin}/contact`, {
      method: 'POST', body: JSON.stringify({ unmark: true }),
    }),
    detail: (cin) => apiFetch(`/api/companies/${cin}/detail`),
  },

  mgt7a: {
    status:  ()           => apiFetch('/api/mgt7a/status'),
    records: (params = {}) => apiFetch(`/api/mgt7a/records?${new URLSearchParams(params)}`),
    export:  (params = {}) => exportDownload('/api/mgt7a/export', params),
  },

  gst: {
    summary:   ()           => apiFetch('/api/gst/summary'),
    byState:   ()           => apiFetch('/api/gst/by-state'),
    records:   (params = {}) => apiFetch(`/api/gst/records?${new URLSearchParams(params)}`),
    noGst:     (params = {}) => apiFetch(`/api/gst/no-gst?${new URLSearchParams(params)}`),
    panDetail: (pan)        => apiFetch(`/api/gst/pan/${pan}`),
    export:    (params = {}) => exportDownload('/api/gst/export', params),
  },

  iec: {
    summary: ()           => apiFetch('/api/iec/summary'),
    records: (params = {}) => apiFetch(`/api/iec/records?${new URLSearchParams(params)}`),
    export:  (params = {}) => exportDownload('/api/iec/export', params),
  },
  icegate: {
    summary: ()           => apiFetch('/api/icegate/summary'),
    records: (params = {}) => apiFetch(`/api/icegate/records?${new URLSearchParams(params)}`),
  },
  suppliers: {
    records: (params = {}) => apiFetch(`/api/suppliers/records?${new URLSearchParams(params)}`),
    export:  (params = {}) => exportDownload('/api/suppliers/export', params),
    filterOptions: () => apiFetch('/api/suppliers/filter-options'),
  },

  senders: {
    list:   ()              => apiFetch('/api/senders'),
    create: (payload)       => apiFetch('/api/senders', { method: 'POST', body: JSON.stringify(payload) }),
    update: (id, payload)   => apiFetch(`/api/senders/${id}`, { method: 'PUT', body: JSON.stringify(payload) }),
    remove: (id)            => apiFetch(`/api/senders/${id}`, { method: 'DELETE' }),
  },

  campaigns: {
    list:   ()              => apiFetch('/api/campaigns'),
    create: (payload)       => apiFetch('/api/campaigns', { method: 'POST', body: JSON.stringify(payload) }),
    detail: (id)            => apiFetch(`/api/campaigns/${id}`),
    remove: (id)            => apiFetch(`/api/campaigns/${id}`, { method: 'DELETE' }),
    start:  (id)            => apiFetch(`/api/campaigns/${id}/start`, { method: 'POST' }),
    pause:  (id)            => apiFetch(`/api/campaigns/${id}/pause`, { method: 'POST' }),
    recipients: (id, params = {}) => apiFetch(`/api/campaigns/${id}/recipients?${new URLSearchParams(params)}`),
    pasteRecipients: (id, text)   => apiFetch(`/api/campaigns/${id}/recipients/paste`, {
      method: 'POST', body: JSON.stringify({ text }),
    }),
    testSend: (payload) => apiFetch('/api/campaigns/test-send', {
      method: 'POST', body: JSON.stringify(payload),
    }),
    uploadRecipients: async (id, file, sheetName) => {
      const form = new FormData();
      form.append('file', file);
      if (sheetName) form.append('sheetName', sheetName);
      const res = await fetch(`/api/campaigns/${id}/recipients/upload`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        body: form,
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({ error: res.statusText }));
        throw new Error(err.error || 'Upload failed');
      }
      return res.json();
    },
  },
};
